'use client';

import React, { useEffect, useMemo, useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import { BannerStyles, ButtonStyles, Container } from './CookieBanner.styled';
import { useAppSelector } from '../../hooks/reduxHooks';
import { RobotoFont } from '../../styles/fonts';
import LocalizedLink from '../Link/localized-link';

function CookieBanner() {
  const [hide, setHide] = useState<boolean>(false);
  const locale = useAppSelector((st) => st.locale);

  const messages = useMemo(() => {
    return {
      text1: locale['cookie_banner_text_0'],
      text2: locale['cookie_banner_text_1'],
      button_text: locale['cookie_banner_button_accept'],
    };
  }, [locale]);

  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  if (hide || !isShown) return null;

  return (
    <CookieConsent
      location='bottom'
      debug={process.env.NODE_ENV === 'development'}
      style={BannerStyles}
      buttonStyle={ButtonStyles}
      buttonText={`${messages.button_text}`}
      acceptOnOverlayClick
      expires={365}
    >
      <Container>
        <span
          style={{
            fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
            fontWeight: 300,
            fontSize: '18px',
            lineHeight: '30px',
            letterSpacing: '-.75px',
          }}
        >
          {messages.text1}{' '}
          <LocalizedLink
            className='privacy-policy'
            href={`/privacy-policy`}
            onClick={() => {
              setHide(true);
            }}
          >
            {messages.text2}
          </LocalizedLink>
          .
        </span>
      </Container>
    </CookieConsent>
  );
}

export default CookieBanner;
